var tagRegex = /<[^>]+>/g;
export var cleanRichText = function (value) {
    if (value === void 0) { value = ''; }
    return value.replace(tagRegex, '');
};
